import React, { Component } from 'react'
import * as PropTypes from 'prop-types'

import './NutrientDistributionEditor.css'

export default class NutrientDistributionEditor extends Component<any, any> {
  static propTypes = {
    energyDistribution: PropTypes.object.isRequired,
    updateNutrientDistribution: PropTypes.func,
    showValidation: PropTypes.bool,
    header: PropTypes.string,
  }

  render() {
    const { energyDistribution, showValidation, header, disabled } = this.props

    const proteinDistribution = Math.round(energyDistribution.proteinDistribution * 10000.0) / 100.0
    const fatDistribution = Math.round(energyDistribution.fatDistribution * 10000.0) / 100.0
    const carbohydratesDistribution =
      Math.round(energyDistribution.carbohydratesDistribution * 10000.0) / 100.0

    const nutrientsTotal = proteinDistribution + fatDistribution + carbohydratesDistribution

    return (
      <div className="energy-dist">
        {header != null && header.length > 0 && <h3>{header}</h3>}

        <div className="energy-dist__content">
          <div className="form-group">
            <label>Protein</label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                placeholder="Protein Kcal Distribution"
                name="proteinDistribution"
                value={!isNaN(proteinDistribution) ? proteinDistribution : ''}
                onChange={(ev) =>
                  this.props.updateNutrientDistribution(
                    ev.target.name,
                    parseInt(ev.target.value) / 100,
                  )
                }
                disabled={disabled}
              />
              <div className="input-group-append">
                <span className="input-group-text">%</span>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Fat</label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                placeholder="Fat Kcal Distribution"
                name="fatDistribution"
                value={!isNaN(fatDistribution) ? fatDistribution : ''}
                onChange={(ev) =>
                  this.props.updateNutrientDistribution(
                    ev.target.name,
                    parseInt(ev.target.value) / 100,
                  )
                }
                disabled={disabled}
              />
              <div className="input-group-append">
                <span className="input-group-text">%</span>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Carbohydrates</label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                placeholder="Carbohydrates Kcal Distribution"
                name="carbohydratesDistribution"
                value={!isNaN(carbohydratesDistribution) ? carbohydratesDistribution : ''}
                onChange={(ev) =>
                  this.props.updateNutrientDistribution(
                    ev.target.name,
                    parseInt(ev.target.value) / 100,
                  )
                }
                disabled={disabled}
              />
              <div className="input-group-append">
                <span className="input-group-text">%</span>
              </div>
            </div>
          </div>

          <div className="form-group">
            <span>Total: </span>
            <span>{!isNaN(nutrientsTotal) ? nutrientsTotal + '%' : ''}</span>
          </div>
        </div>

        {showValidation && (
          <div className="alert-danger alert">Sum of kcal distribution should be 100%</div>
        )}
      </div>
    )
  }
}
